module.exports = __webpack_public_path__ + "static/img/1810_2.3b8a967.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_2.jpg
// module id = BlwU
// module chunks = 1